import { Typography } from "@mui/material"
import { ReactNode } from "react"
import { Link } from "react-router-dom"

type PropsType = {
    icon: ReactNode,
    title: string,
    to: string,
}

export default function Service({ icon, title, to }: PropsType) {
    return (
        <Link to={to} className="flex flex-col rounded-lg gap-4 items-center px-7 py-6 md:py-8 text-primary-contrastText bg-primary-main/70 hover:bg-primary-outborder active:bg-primary-main shadow-md shadow-primary-contrastText/15 hover:shadow-none border-t-2 border-transparent active:border-primary-contrastText">
            {icon}
            <Typography>{title}</Typography>
        </Link>
    )
}